import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 11: Drive</h1>
          <p className="white"><b>How to resist the crab-grab and pursue your dreams</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Write it down. Make a list and put your dreams and goals on paper. Use as much detail as possible. Don’t limit yourself.
            </li>
            <li>Manifest and visualize. Give yourself permission to daydream. Act like an Olympian and visualize your goal being accomplished. Picture it so vividly that you feel it and believe it. Focus on the ‘why.’ Why do you want it? What would accomplishing it do for yourself and others?
            </li>
            <li>Repeat. Visualize your goal often. The more you do it, the more deeply you etch it into your psyche. When you wake up, think of your goal. When you go to bed, imagine it as done. Become obsessed with it and let the excitement of its achievement consume you.
            </li>
            <li>Take action. Determine the steps you need to take in order to accomplish that goal. What kind of person do you need to become in order to achieve what you want? Is there someone else who has accomplished that goal already? Research and study them. How did they do it? If a goal feels so out of reach that you get disheartened and feel like it isn’t possible, then look for others who have already done it. Seeing the success of others can remind you that it has been done so it can be done by you too. It is harder to be the first because you have to pave the way. Look at others’ successes as a path that has already been cleared. Learn from their mistakes and observe their wins, then make it your own.
            </li>
            <li>Trust in the process. Remember that life is still pretty fucking awesome even if you haven’t achieved your goal yet. Enjoy the journey and remember that progress is happiness. Taking steps toward your goal and celebrating the wins is what will keep you going even in times of doubt. Remember that if you are making an effort, life will step in and meet you halfway (or more). Be open to grace and guidance. Life may take you off of the path that you see as the only way to achieve what you want, and you must trust it. It may be taking you somewhere greater than you could have ever imagined.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter11.js